document.querySelectorAll('desktop-navigation.pe-navigation').forEach((navigation) => {
  let restoringFocus = false;
  const closeAll = (except) => {
    navigation.querySelectorAll('.has-dropdown').forEach((item) => {
      if (item !== except && item.querySelector('[aria-expanded="true"]')) navigation.closeDropdown(item);
    });
  };
  navigation.addEventListener('focusin', (event) => {
    if (restoringFocus) return;
    const item = event.target.closest('.has-dropdown');
    closeAll(item);
    if (item && event.target.matches('.header__linklist-link')) navigation.openDropdown(item);
  });
  navigation.addEventListener('focusout', () => {
    setTimeout(() => { if (!navigation.contains(document.activeElement)) closeAll(); }, 0);
  });
  navigation.addEventListener('keydown', (event) => {
    const item = event.target.closest('.has-dropdown');
    if (!item) return;
    const trigger = item.querySelector('.header__linklist-link');
    if (event.key === 'ArrowDown' && event.target === trigger) {
      event.preventDefault();
      navigation.openDropdown(item);
      setTimeout(() => item.querySelector('.mega-menu a')?.focus(), 150);
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      restoringFocus = true;
      trigger.focus();
      restoringFocus = false;
      navigation.closeDropdown(item);
    }
  });
  document.addEventListener('click', (event) => { if (!navigation.contains(event.target)) closeAll(); });
});
